"use client"
import 'aos/dist/aos.css';
import 'aos/dist/aos.js';
import YouTube from "react-youtube";
import { useEffect, useRef } from 'react';

const Mission = () => {
    const opts = {
        height: "390",
        width: "100%",
        playerVars: {
            autoplay: false,
            rel: 0, 
            modestbranding: 1, 
            controls: 1,
            showinfo: 0, 
            fs: 0, 
            disablekb: 1, 
            iv_load_policy: 3, 
        },
    };
    const playerRef = useRef(null);
    const onReady = (event: { target: any; }) => {
        // Access to player in all event handlers via event.target.
        playerRef.current = event.target;
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const AOS = require('aos');
            AOS.init();
        }
    }, []);

    return (
        <section className="bg-[#FFFFFF] py-7 lg:py-14 md:py-14">
            <div className="container" data-aos="fade-up" data-aos-duration="1000">
                <div className="grid grid-cols-1">
                    <div className="text-center">
                        <div>
                            <h2 className="text-gray lg:text-[32px] md:text-[24px] text-[20px] font-semibold lg:mb-6 mb-4 leading-tight">Vision</h2>
                            <ul className='list-disc text-[#000000] font-normal lg:text-[16px] text-[1rem] mb-0 max-w-[700px] m-auto text-start space-y-2'>
                                <li>Building a Skilled Workforce to Meet Industry Demand and Drive Technological Growth</li>
                                <li>Ensuring Every Student Gains the Right Skills to Thrive in the Evolving Tech Landscape</li>
                            </ul>
                        </div>
                        <div className='pt-7 lg:pt-14 md:pt-14'>
                            <h2 className="text-gray lg:text-[32px] md:text-[24px] text-[20px] font-semibold lg:mb-4 mb-4 leading-tight">Presenting the ExC Academy!</h2>
                        </div>
                        <div className='flex justify-center w-full'>
                            <YouTube className='max-w-[640px] w-full' videoId="zfDtbddLmXU" opts={opts} onReady={onReady} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Mission;